import { useTranslation } from "react-i18next";

import { DeleteOutlineIcon } from "@dotnet/telematics-design-system";

import {
  COMPANIES_ACTIONS,
  ICON_DEFAULT_STYLE
} from "../../../../../../../../../../shared";
import ListChoice from "../../../../../../../../../ListChoice/ListChoice";
import { useDialog } from "../../../../../../../../../PageHeader/actions/hooks/useDialog";
import { EmailTransferProps } from "../../../../types";
import RemoveEmailRecipientDialog from "./RemoveEmailRecipientDialog";

const RemoveEmailRecipient = ({
  card,
  companyId,
  onActionsMenu
}: EmailTransferProps) => {
  const { t } = useTranslation();

  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  const handleOpenDialog = () => {
    openDialog(COMPANIES_ACTIONS.RemoveEmailRecipient);
  };

  const handleCloseDialog = () => {
    onActionsMenu(null);
    closeDialog(COMPANIES_ACTIONS.RemoveEmailRecipient);
  };

  return (
    <>
      <ListChoice
        data-testid="remove-email-recipient-menu-choice"
        title={t("Details##remove")}
        onClick={handleOpenDialog}
        iconLeft={<DeleteOutlineIcon style={ICON_DEFAULT_STYLE} />}
        alignIconCenter
      />
      <RemoveEmailRecipientDialog
        companyId={companyId}
        open={isDialogOpen[COMPANIES_ACTIONS.RemoveEmailRecipient]}
        onClose={handleCloseDialog}
        cardData={card}
      />
    </>
  );
};

export default RemoveEmailRecipient;
